export interface Employee {
  id: number;
  name: string;
  email: string;
  phone?: string;
  department?: string;
  position?: string;
  hireDate: Date;
  birthDate: Date;
  workplace?: string;
  skills?: string;
}

export interface Document {
  id: number;
  employeeId: number;
  documentType: DocumentType;
  title: string;
  issueDate: Date;
  expiryDate: Date;
  status: DocumentStatus;
  notificationsSent: NotificationRecord[];
  documentUrl?: string;
  notes?: string;
  cv_summary?: string;
  cv_analysis_status?: CVAnalysisStatus;
  cv_analysis_date?: Date;
  file_name?: string;
  file_path?: string;
  file_type?: string;
  file_size?: number;
}

export interface DocumentType {
  id: number;
  name: string;
  status: number;
}

export enum DocumentStatus {
  Valid = 'valid',
  Expiring = 'expiring',
  Expired = 'expired',
  Missing = 'missing'
}

export enum CVAnalysisStatus {
  Pending = 'pending',
  Processing = 'processing',
  Completed = 'completed',
  Failed = 'failed'
}

export interface NotificationRecord {
  id: number;
  documentId: number;
  employeeId: number;
  notificationType: NotificationType;
  sentDate: Date;
  channel: NotificationChannel;
  success: boolean;
}

export enum NotificationType {
  DocumentExpiring = 'documentExpiring',
  DocumentExpired = 'documentExpired',
  Birthday = 'birthday',
  WorkAnniversary = 'workAnniversary'
}

export enum NotificationChannel {
  Email = 'email',
  SystemPush = 'systemPush',
  Both = 'both'
}

export interface PersonalEvent {
  id: number;
  employeeId: number;
  eventType: PersonalEventType;
  date: Date;
  notificationSent: boolean;
}

export enum PersonalEventType {
  Birthday = 'birthday',
  WorkAnniversary = 'workAnniversary'
}

export interface DocumentSummary {
  totalDocuments: number;
  validDocuments: number;
  expiringDocuments: number;
  expiredDocuments: number;
  missingDocuments: number;
}

export interface NotificationSettings {
  documentExpiryReminderDays: number[]; // e.g., [30, 15, 7, 1]
  birthdayReminderDays: number; // How many days before to send birthday reminders
  anniversaryReminderDays: number; // How many days before to send anniversary reminders
  defaultNotificationChannel: NotificationChannel;
  hrEmailAddresses: string[]; // HR staff who should receive notifications
}
